import { Component, Input, OnInit, Output, EventEmitter, Inject } from '@angular/core'
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet'
import { BottomSheetConfirmationDto } from 'src/app/data/models/dto/bottom-sheet-confirmation.dto'

@Component({
  selector: 'app-bottom-sheet-confirmation',
  templateUrl: './bottom-sheet-confirmation.component.html',
  styleUrls: ['./bottom-sheet-confirmation.component.scss']
})
export class BottomSheetConfirmationComponent implements OnInit {

  @Input() message: string = ''
  @Input() btnCancelText: string = ''
  @Input() btnConfirmText: string = ''
  @Input() isAgenda: boolean = false

  constructor(private bottomSheetRef: MatBottomSheetRef<BottomSheetConfirmationComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) private data: BottomSheetConfirmationDto) { }

  ngOnInit(): void {
    this.message = this.data.message
    this.btnCancelText = this.data.btnCancelText
    this.btnConfirmText = this.data.btnConfirmText
    this.data.confirmed = false
    this.isAgenda = this.data.isAgenda ?? false
  }

  cancel() {
    this.bottomSheetRef.dismiss(this.data)
  }

  confirm() {
    this.data.confirmed = true
    this.bottomSheetRef.dismiss(this.data)
  }

}
